<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <div style="position: absolute; right: 3px; top: 3px">
        <v-btn flat icon color="grey" @click="edit = true" v-if="userAuthClass">
          <v-icon>edit</v-icon>
        </v-btn>
      </div>

      <div class>
        <v-avatar :color="color" size="66" class="overlap-avatar">
          <span class="white--text headline">{{letter.toUpperCase()}}</span>
        </v-avatar>
      </div>

      <v-card-text>
        <div class="pb-1">
          <h5 class="subheading font-weight-regular text-capitalize">{{tip.name}}</h5>
        </div>
        <div class="pb-4">
          <h5 class="subheading font-weight-regular grey--text text--darken-1">{{tip.number}}</h5>
        </div>
        <div class="pb-4">
          <h5 class="subheading font-weight-regular grey--text text--darken-1">{{tip.contactEmail}}</h5>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn flat icon color="grey" :href="'mailto:'+tip.contactEmail" v-if="!!tip.contactEmail">
          <v-icon>mail</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :subject="tip" :time="tip.updatedAt" needsParse updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>


      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT DRIVER DIALOG -->
    <v-dialog
      v-model="edit"
      max-width="700px"
      lazy
      @keydown.esc="edit = false"
      v-if="userAuthClass"
    >
      <edit-tip :tip="tip" @close="edit = false" @tipEdited="displaySnack"></edit-tip>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog
      v-model="deleteDialog"
      max-width="400px"
      @keydown.esc="deleteDialog = false"
      lazy
      v-if="userAuthClass"
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{tip.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteTip(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import TipService from "@/services/requests/tipService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditTip from "@/components/tips/editTip";
import DisplaySnack from "@/services/mixins/displaySnack";

export default {
  components: {
    EditTip
  },
  mixins: [DisplaySnack],
  data() {
    return {
      edit: false,
      deleteDialog: false
    };
  },
  methods: {
    deleteTip() {
      var tip = this.tip;
      TipService.deleteTip(tip.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("tips/deleteFromArrayStateByValue", {
            prop: "tips",
            value: tip
          });
          this.snack({ text: "Tip was deleted!", color: "yellow" });
        })
        .catch(err => {
          //console.log("An error occured");
          this.snackError();
        });
    }
  },
  props: {
    tip: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.tip.name.charCodeAt(0));
    },
    letter() {
      return this.tip.name.charAt(0);
    }
  },
  components: {
    EditTip
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -35px;
  border: 6px solid #eee;
  border-color: #eee !important;
}
</style>
